import { Component, computed, inject, input, output } from '@angular/core';

import {
  formatCellValue,
  processUidValue
} from '@shared/components/table/table-cell/utils';
import { ReferencePopupService } from '@shared/services/reference-popup/reference-popup.service';

import { CellOverlayAction } from '../../actions-overlay/actions-overlay.component';
import { UidLabelResolver } from '../../uid-label-resolver';

@Component({
  selector: 'app-uid-cell',
  imports: [],
  templateUrl: './uid-cell.component.html',
  styles: `
    :host {
      display: flex;
    }
  `
})
export class UidCellComponent {
  private readonly referencePopupService = inject(ReferencePopupService);

  availableCellActions: CellOverlayAction[] = ['copy', 'filter'];
  availableCellShiftActions: CellOverlayAction[] = ['copy_raw'];
  valueAsString = (v: unknown) => formatCellValue(v, 'uid');

  value = input<unknown | undefined>(undefined);
  displayLabelFor = input<UidLabelResolver | undefined>(undefined);
  targetEntityType = input<string | undefined>(undefined);
  columnId = input<string | undefined>(undefined);
  row = input<unknown>(undefined);

  uidClick = output<string>();

  protected processedValue = computed<string | undefined>(() =>
    processUidValue(this.value())
  );

  protected displayLabel = computed<string | undefined>(() => {
    const uid = this.processedValue();
    if (uid == null) return undefined;
    return this.displayLabelFor()?.(uid) ?? uid;
  });

  protected onClick(event: MouseEvent): void {
    const uid = this.processedValue();
    if (uid == null) return;

    const targetEntityType = this.targetEntityType();
    if (targetEntityType) {
      this.referencePopupService.open(event.currentTarget as HTMLElement, {
        uid,
        targetEntityType,
        column: this.columnId() ?? '',
        row: this.row()
      });
      return;
    }
    this.uidClick.emit(uid);
  }

  filterValue(): string | undefined {
    return this.processedValue();
  }
}
